import React from "react"
import GenericModal from "../../../../components/modal/generic-modal"
import PropTypes from "prop-types"

const DuplicarEventos = ({open, onClose}) => {

    const closeModal = () => {

        if (onClose) {
            onClose()
        }
     }

    return (
        <GenericModal
            isOpen={open}
            onClose={closeModal}
            title={"Duplicar Cadastro"}>
            <h1></h1>
        </GenericModal>
    )
}

DuplicarEventos.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
}

export default DuplicarEventos